module.exports = "/_next/static/resources/photo-2-1ab9a51becd1dfaa63eef3fb6208c3d7.webp";